import { Box, Typography } from '@mui/material';

/**
 * The properties for the count row
 */
interface CountRowProps {
  /** The icon to use in the count row */
  icon: JSX.Element;
  /** The title to use for the count row */
  title: string;
  /** The actual count */
  count: number;
}

/** The count row to show in the dashboard */
const CountRow = (props: CountRowProps) => (
  <Box display="flex" justifyContent="space-between" marginY=".75em">
    <Box display="flex" gap="1em" alignItems="center">
      {props.icon}
      <Typography fontSize="1.2em">{props.title}</Typography>
    </Box>
    <Typography fontSize="1.2em" fontWeight="bold">
      {props.count}
    </Typography>
  </Box>
);

export default CountRow;
